const React = require("react");
const withState = require('../../../utils/withState');
const {CC_CODES} = require("../../../constants/codes");
const {NETWORKS_NAMES} = require("../../../constants/networks");

const Select = require('../Select/B');
const noop = require("mn-utils/noop");

module.exports = withState((setState, self) => {
  const coinsList = [];
  const networks = {};
  const filterFn = self.props.filterFn;

  CC_CODES.filter(filterFn ? filterFn : (el) => el).forEach((code) => {
    const [network, coin] = code.includes('_') ? code.split('_') : ['', code];
    if (!coinsList.includes(coin)) coinsList.push(coin);

    if (!network) return;

    if (!networks[coin]) networks[coin] = [];
    networks[coin].push({id: network, name: NETWORKS_NAMES[network] || network});
  });

  self.state = {
    ...self.state,
    coinsList,
    networks
  }

  const pushNextState = (nextState) => {
    const {id, codeProps = {}, networkProps = {}, onChange = noop} = self.props;

    const nextNetwork = nextState[networkProps.id];
    const nextCode = nextState[codeProps.id];

    nextState[id] = nextNetwork
      ? [nextNetwork, nextCode].join('_')
      : nextCode;

    if (onChange) onChange(nextState);
  }

  const onCodeSelectorChange = (code) => {
    const {codeProps = {}, networkProps = {}} = self.props;

    const nextNetworksList = networks[code];
    const selectedNetwork = nextNetworksList
      ? nextNetworksList[0].id
      : '';

    pushNextState({
      [codeProps.id]: code,
      [networkProps.id]: selectedNetwork,
    });
  }

  const onNetworkSelectorChange = (val) => {
    const {codeProps = {}, networkProps = {}} = self.props;

    const code = codeProps.value;

    pushNextState({
      [codeProps.id]: code,
      [networkProps.id]: val,
    });
  }

  return (state, props) => {
    const {coinsList = [], networks = {}} = state;
    const {
      className,
      codeProps,
      networkProps,
      clicked
    } = props;

    const code = codeProps.value;

    const networksList = !code
      ? []
      : !!networks[code]
        ? networks[code]
        : [{id: code, name: NETWORKS_NAMES[code] || code}];

    return (
      <>
        <div className={className}>
          <Select
            items={coinsList}
            onChange={onCodeSelectorChange}
            error={clicked && !code}
            displayEmpty

            {...codeProps}
          />
        </div>
        <div className={className}>
          <Select
            label={networkProps.label}
            propValue="id"
            propName="name"
            items={networksList}
            value={code && networksList.length < 2 ? networksList[0].id : networkProps.value}
            onChange={onNetworkSelectorChange}
            disabled={networksList.length < 2}
            displayEmpty
          />
        </div>
      </>
    )
  }
})
